import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Alert } from "reactstrap";

import {
    resetGetViewConfigurationList,
    getViewConfigurationAdminList
} from "../../redux/actions/getViewConfigurationAdminAction";
import Layout from "../../components/Wrappers/Layout";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box,
    withWidth
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";

function AdminViewConfiguration() {
    const location = useLocation();
    const dispatch = useDispatch();

    // THIS IS FOR ROLE AND WALLET OWNER ID
    const role = location.search.split("?userId=")[1].split("&")[0];
    const WalletOwnwerFromSearch = location.search.split("=")[2];



    const [getConfigViewStatus, setGetConfigViewStatus] = useState(false);
    const [getConfigViewRes, setGetConfigViewRes] = useState("");

    // Market Place
    const [dealRequired, setDealRequired] = useState("");
    const [orderMgtAllowed, setOrderMgtAllowed] = useState("");
    const [prdMgtAllowed, setPrdMgtAllowed] = useState("");
    const [orderSellReportAllowed, setorderSellReportAllowed] = useState("");
    const [isPromoCodeAllowed, setIsPromoCodeAllowed] = useState("");

    //Sign Up and Login
    const [merchantRequired, setMerchantRequired] = useState("");
    const [newDeviceCheckAllowed, setNewDeviceCheckAllowed] = useState("");
    const [changePasswordAllowed, setchangePasswordAllowed] = useState("");
    const [dealerMappingRequired, setDealerMappingRequired] = useState("");

    const [prefixAccountId, setPrefixAccountId] = useState("");
    const [customerCreationAllowed, setCustomerCreationAllowed] = useState("");
    const [emailAllowed, setEmailAllowed] = useState("");
    const [smsAllowed, setSmsAllowed] = useState("");

    const [businessSignupAllowed, setBusinessSignupAllowed] = useState("");
    const [maxUboCount, setmaxUboCount] = useState("");
    const [maxDirectorCount, setmaxDirectorCount] = useState("");
    const [autoFilledAllowed, setautoFilledAllowed] = useState("");

    const [addBankDuringSignUp, setaddBankDuringSignUp] = useState("");
    const [dateOfBirthRequired, setdateOfBirthRequired] = useState("");
    const [nationalityRequired, setnationalityRequired] = useState("");
    const [kycRequired, setKycRequired] = useState("");
    const [custCreationAll, setcustCreationAll] = useState('');
    const [dobReqired, setdobReqired] = useState('');

    // Prepaid Card

    const [customerActivateCardRequired, setCustomerActivateCardRequired] =
        useState("");
    const [prepaidCardFeatureRequired, setprepaidCardFeatureRequired] =
        useState("");
    const [applyingPrepaidCardDuringSignUp, setapplyingPrepaidCardDuringSignUp] =
        useState("");

    // Wallet Settings
    const [isSEPAAllowed, setisSEPAAllowed] = useState('');
    const [myIbanAllowed, setmyIbanAllowed] = useState('');
    const [loadMoneyAllowed, setLoadMoneyAllowed] = useState("");
    const [withdrawMoneyAllowed, setWithdrawMoneyAllowed] = useState("");
    const [sendMoneyAllowed, setsendMoneyAllowed] = useState("");
    const [requestMoneyAllowed, setRequestMoneyAllowed] = useState("");

    const [activityLogAllowed, setactivityLogAllowed] = useState("");
    const [walletAllowed, setWalletAllowed] = useState("");
    const [payAllowed, setpayAllowed] = useState("");
    const [payOption, setpayOption] = useState("");

    const [walletTransferAllowed, setwalletTransferAllowed] = useState("");
    const [cashoutAllowed, setcashoutAllowed] = useState("");
    const [checkDepositAllowed, setcheckDepositAllowed] = useState("");
    const [payOrderAllowed, setPayOrderAllowed] = useState("");

    const [payReceivedAllowed, setpayReceivedAllowed] = useState("");
    const [cashInAllowed, setcashInAllowed] = useState("");
    const [requestCashInAllowed, setrequestCashInAllowed] = useState("");
    const [requestCashOutAllowed, setrequestCashOutAllowed] = useState("");

    const [withdrawVerificationAllowed, setwithdrawVerificationAllowed] =
        useState("");
    const [sendMoneyMerchantRequired, setsendMoneyMerchantRequired] =
        useState("");
    const [radioAllowed, setradioAllowed] = useState("");
    const [blockChainAllowed, setblockChainAllowed] = useState("");
    const [rechargeAllowed, setrechargeAllowed] = useState("");

    const [myCardAllowed, setyCardAllowed] = useState("");
    const [myBankAllowed, setmyBankAllowed] = useState("");
    const [loyaltyPointsAllowed, setloyaltyPointsAllowed] = useState("");
    const [transactionHistoryAllowed, settransactionHistoryAllowed] =
        useState("");
    const [walletHistoryAllowed, setwalletHistoryAllowed] = useState("");
    const [profileSettingsAllowed, setprofileSettingsAllowed] = useState("");
    const [billPaymentAllowed, setbillPaymentAllowed] = useState("");
    const [donationAllowed, setdonationAllowed] = useState("");
    const [loadwithWalletAllowed, setloadwithWalletAllowed] = useState("");
    const [integration, setintegration] = useState("");
    const [sendSecurityAllowed, setendSecurityAllowed] = useState("");
    const [loadSecurityAllowed, setloadSecurityAllowed] = useState("");
    const [requestSecurityAllowed, setrequestSecurityAllowed] = useState("");
    const [withdrawSecurityAllowed, setwithdrawSecurityAllowed] = useState("");
    const [paySecurityAllowed, setpaySecurityAllowed] = useState("");
    const [cashoutSecurityAllowed, setcashoutSecurityAllowed] = useState("");
    const [payOrderSecurityAllowed, setpayOrderSecurityAllowed] = useState("");
    const [purchaseSecurityAllowed, setpurchaseSecurityAllowed] = useState("");
    const [cashinSecurityAllowed, setcashinSecurityAllowed] = useState("");
    const [userManagement, setuserManagement] = useState("");
    const [storeRequired, setstoreRequired] = useState("");

    const [voucherPurchaseAllowed, setvoucherPurchaseAllowed] = useState("");

    const [transactionHistoryAllowedv, settransactionHistoryAllowedv] =
        useState("");
    const [myVoucherAllowed, setmyVoucherAllowed] = useState("");
    const [redeemPasswordAllowed, setredeemPasswordAllowed] = useState("");

    const [redeemAuthentication, setredeemAuthentication] = useState("");
    const [redeemExactOrderAmount, setredeemExactOrderAmount] = useState("");
    const [settlementReportRequired, setsettlementReportRequired] = useState("");
    const [aPIKeyRequired, setaPIKeyRequired] = useState("");

    const [sendToContactAllowed, setsendToContactAllowed] = useState('');
    const [sendToSelfAllowed, setsendToSelfAllowed] = useState('');
    const [sendToOtherAllowed, setsendToOtherAllowed] = useState('');
    const [checkBalanceAllowed, setcheckBalanceAllowed] = useState('');
    const [manageBeneficiariesAllowed, setmanageBeneficiariesAllowed] = useState('');

    const [getRefund, setGetRefund] = useState('');
    const [getFullRefund, setGetFullRefund] = useState('');
    const [getPartialRefund, setGetPartialRefund] = useState('')

    //Transaction configuration
    const [getIsTermsAndConditions, setGetIsTermsAndConditions] = useState('');
    // const [getTermsURL, setGetTermsURL] = useState("");
    const [getRedirectTime, setGetRedirectTime] = useState("");
    const [getIsAutoRedirect, setGetIsAutoRedirect] = useState("");
    const [countrySelection, setcountrySelection] = useState('N');
    //Two Factor Authentucation

    const [twofaSmsOtpAllowed, settwofaSmsOtpAllowed] = useState('');
    const [twofaEmailOtpAllowed, settwofaEmailOtpAllowed] = useState('');
    const [twofaConfigurationUser, settwofaConfigurationUser] = useState('');
    const [twofaconfigurationGoogle, settwofaconfigurationGoogle] = useState('');

    //Consent (Transaction and Sign Up)
    const [getSignUpConsent, setGetSignUpConsent] = useState('');
    const [getTransactionConsent, setGetTransactionConsent] = useState('')

    // WALLET OWNER ID VIEW
    const [walletOwner, setWalletOwner] = useState("");

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    const getWalletRolesRes = useSelector(
        ({ walletAcRequired }) => walletAcRequired
    );


    const getConfigurationViewListApiFun = (role) => {
        setGetConfigViewStatus(true);
        const getViewCongigurationListsReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: WalletOwnwerFromSearch || "",   //regenerateTokenRes.data.partnerId
                role: role == "Select Role" ? "" : role
            }
        };
        return dispatch(
            getViewConfigurationAdminList(
                getViewCongigurationListsReq,
                regenerateTokenRes.data.AuthToken
            )
        );
    };


    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getConfigurationViewListApiFun(role);
        }
    }, [regenerateTokenRes.data.AuthToken]);

    const getViewCongigurationListRes = useSelector(
        ({ getViewConfigurationAdminLists }) => getViewConfigurationAdminLists
    );


    useEffect(() => {
        if (getConfigViewStatus) {
            if (getViewCongigurationListRes.success) {
                setGetConfigViewRes(getViewCongigurationListRes.data);
                setDealRequired(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO.isDealsWant
                        : ""
                );
                setOrderMgtAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .orderSellRptAllowed
                        : ""
                );
                setPrdMgtAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .productMngtAllowed
                        : ""
                );
                setorderSellReportAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .orderSellRptAllowed
                        : ""
                );
                setIsPromoCodeAllowed(
                    getViewCongigurationListRes.data.marketPlaceConfRqeVO
                        ? getViewCongigurationListRes.data.marketPlaceConfRqeVO
                            .isPromoCodeAllowed
                        : ""
                );
                //isPromoCodeAllowed

                setMerchantRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isMerchant
                        : ""
                );
                setchangePasswordAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .changePasswordAllowed
                        : ""
                );
                setDealerMappingRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .dealerMAppingAllowed
                        : ""
                );
                setPrefixAccountId(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.prefixAccountId
                        : ""
                );

                setEmailAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isEmailAllowed
                        : ""
                );
                setSmsAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isSMSAllowed
                        : ""
                );
                setBusinessSignupAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .businessSignupAllowed
                        : ""
                );
                setmaxUboCount(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.uboCount
                        : ""
                );

                setmaxDirectorCount(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.directorCount
                        : ""
                );
                setSmsAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isSMSAllowed
                        : ""
                );
                setautoFilledAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isAutoFilled
                        : ""
                );
                setmaxUboCount(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.uboCount
                        : ""
                );

                setaddBankDuringSignUp(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .isSignUpBankRequired
                        : ""
                );
                setdateOfBirthRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.ifDOBrequired
                        : ""
                );
                setaddBankDuringSignUp(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .isSignUpBankRequired
                        : ""
                );
                setdateOfBirthRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.ifDOBrequired
                        : ""
                );
                setnationalityRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .ifNationalityRequired
                        : ""
                );
                setKycRequired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO
                            .isKycRequired
                        : ""
                );

                setNewDeviceCheckAllowed(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isNewDevice
                        : ''
                );

                setcustCreationAll(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.isCustCreationAllowed
                        : ''
                )
                setdobReqired(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.ifDOBrequired
                        : ''
                )
                settwofaconfigurationGoogle(
                    getViewCongigurationListRes.data.accountConfReqVO
                        ? getViewCongigurationListRes.data.accountConfReqVO.twoFactorGoogle
                        : ''
                )

                //Sign Up and Login  End

                //Prepaid Card start

                setCustomerActivateCardRequired(
                    getViewCongigurationListRes.data.preparedCardRqeVO
                        ? getViewCongigurationListRes.data.preparedCardRqeVO
                            .allowCustomerToActivateCard
                        : ""
                );
                setprepaidCardFeatureRequired(
                    getViewCongigurationListRes.data.preparedCardRqeVO
                        ? getViewCongigurationListRes.data.preparedCardRqeVO
                            .isPrepaidCardFeatureRequired
                        : ""
                );

                setapplyingPrepaidCardDuringSignUp(
                    getViewCongigurationListRes.data.preparedCardRqeVO
                        ? getViewCongigurationListRes.data.preparedCardRqeVO.prepaidCard
                        : ""
                );

                //Prepaid Card end

                // Wallet Settings  start
                setLoadMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isLoadMoneyAllowed
                        : ""
                );
                setWithdrawMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isWithdrawMoneyAllowed
                        : ""
                );
                setsendMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isSendMoneyAllowed
                        : ""
                );
                setRequestMoneyAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isRequestMoneyAllowed
                        : ""
                );

                setactivityLogAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isActivityLogAllowed
                        : ""
                );
                setWalletAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isMyWalletAllowed
                        : ""
                );
                setpayAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayAllowed
                        : ""
                );
                setpayOption(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.payOption
                        : ""
                );

                setrequestSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.requestPinAllowed
                        : ""
                );

                setwalletTransferAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isWalletTransferAllowed
                        : ""
                );
                setcashoutAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCashOutAllowed
                        : ""
                );
                setcheckDepositAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCheckDeposite
                        : ""
                );

                setpayReceivedAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayAllowed
                        : ""
                );
                setcashInAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCashinAllowed
                        : ""
                );
                setrequestCashInAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isRequestCashinAllowed
                        : ""
                );
                setrequestCashOutAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isRequestCashOutAllowed
                        : ""
                );
                setwithdrawVerificationAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isWithdrawalVerification
                        : ""
                );

                setsendMoneyMerchantRequired(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isSendMoneyMerchant
                        : ""
                );

                setradioAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isRadioAllowed
                        : ""
                );

                setblockChainAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isBlockchainAllowed
                        : ""
                );

                setrechargeAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isRechargeAllowed
                        : ""
                );

                setyCardAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isMyCardAllowed
                        : ""
                );

                setmyBankAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isMyBankAllowed
                        : ""
                );

                setloyaltyPointsAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isLoyaltyPointsAllowed
                        : ""
                );

                settransactionHistoryAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .transactionHistAllowed
                        : ""
                );

                setwalletHistoryAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.walletHistAllowed
                        : ""
                );

                setprofileSettingsAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .profileSettingAllowed
                        : ""
                );

                setbillPaymentAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isBillPayment
                        : ""
                );

                setdonationAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isDonation
                        : ""
                );

                setdonationAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isDonation
                        : ""
                );
                setloadwithWalletAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isLoadWithWalletAllowed
                        : ""
                );
                setintegration(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.integrationType
                        : ""
                );
                setendSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.sendPinAllowed
                        : ""
                );

                setloadSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.loadPinAllowed
                        : ""
                );

                setwithdrawSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayAllowed
                        : ""
                );
                setpaySecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayAllowed
                        : ""
                );
                setcashoutSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCashOutAllowed
                        : ""
                );
                setpayOrderSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .payOrderPinAllowed
                        : ""
                );
                setpurchaseSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .purchasePinAllowed
                        : ""
                );
                setcashinSecurityAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO
                            .isCashinSecurityAllowed
                        : ""
                );
                setuserManagement(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isUserManagement
                        : ""
                );
                setstoreRequired(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isStoreRequired
                        : ""
                );

                setmyIbanAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO ?
                        getViewCongigurationListRes.data.walletConfReqVO.isMyIBANAllowed : ''
                )

                setisSEPAAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO ?
                        getViewCongigurationListRes.data.walletConfReqVO.isSEPAAllowed : ''
                )

                //Voucher configuration
                setvoucherPurchaseAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .voucherPurchaseAllowed
                        : ""
                );

                settransactionHistoryAllowedv(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .voucherTransactionHistoryAllowed
                        : ""
                );

                setmyVoucherAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .myVouchersAllowed
                        : ""
                );

                setmyVoucherAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .myVouchersAllowed
                        : ""
                );

                setredeemPasswordAllowed(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .voucherTransPasswordAllowed
                        : ""
                );

                setredeemAuthentication(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .redeemConfiguration
                        : ""
                );

                setredeemExactOrderAmount(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .isRedeemExactOrderAmount
                        : ""
                );

                setsettlementReportRequired(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO
                            .isSettelementRequired
                        : ""
                );
                setaPIKeyRequired(
                    getViewCongigurationListRes.data.voucherConfigurationVO
                        ? getViewCongigurationListRes.data.voucherConfigurationVO.isapikey
                        : ""
                );
                setsendToContactAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isSendToContactAllowed
                        : ''
                );
                setsendToSelfAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isSendToSelfAllowed
                        : ''
                );
                setsendToOtherAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isSendToSelfAllowed
                        : ''
                );
                setcheckBalanceAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCheckBalanceAllowed
                        : ''
                );
                setmanageBeneficiariesAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isManageBeneficiariesAllowed
                        : ''
                );
                setGetRefund(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isRefund
                        : ''
                );
                setGetFullRefund(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isFullRefund
                        : ''
                );
                setGetPartialRefund(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPartialRefund
                        : ''
                );
                setGetIsTermsAndConditions(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isTermsAndConditions
                        : ''
                );
                setcountrySelection(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isCountrySelection
                        : ''
                );
                // setGetTermsURL(
                //     getViewCongigurationListRes.data.walletConfReqVO
                //         ? getViewCongigurationListRes.data.walletConfReqVO.termsUrl
                //         : ''
                // );
                setGetRedirectTime(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.redirectTime
                        : ''
                );
                setGetIsAutoRedirect(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isAutoRedirect
                        : ''
                );
                settwofaSmsOtpAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.twoFactorSMS
                        : ''
                );
                settwofaEmailOtpAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.twoFactorEmail
                        : ''
                );
                settwofaConfigurationUser(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.twoFactorByUser
                        : ''
                );
                setGetSignUpConsent(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.signupConsent
                        : ''
                );
                setGetTransactionConsent(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.transactionConsent
                        : ''
                );
                setPayOrderAllowed(
                    getViewCongigurationListRes.data.walletConfReqVO
                        ? getViewCongigurationListRes.data.walletConfReqVO.isPayOrder
                        : ""
                );

            }
        }
    }, [getViewCongigurationListRes.success]);

    const handleChange = ({ target: { name, value } }) => {
        // if (name === "deals") {
        //   setRole(value == "Deals Required" ? "" : value);
        // }
    };


    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                // select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Wallet Owner Id"
                                fullWidth
                                variant="standard"
                                type="text"
                                disabled
                                name="OwnerId"
                                // value={WalletOwnwerFromSearch} 
                                defaultValue={WalletOwnwerFromSearch}
                            >
                                <MenuItem value="WalletOwnwerFromSearch">
                                    {WalletOwnwerFromSearch}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                // select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Role"
                                fullWidth
                                variant="standard"
                                type="text"
                                disabled
                                name="role"
                                defaultValue={role}
                            // onChange={handleChange}
                            >
                                <MenuItem value="Select Role" selected="Select Role">
                                    Select Role
                                </MenuItem>

                                {getWalletRolesRes.data.rolesList &&
                                    getWalletRolesRes.data.rolesList &&
                                    []
                                        .concat(getWalletRolesRes.data.rolesList)
                                        .map((dropdown) => (
                                            <MenuItem value={dropdown}>{dropdown}</MenuItem>
                                        ))}
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Market Place </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Deals Required"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={dealRequired || ""}
                                disabled
                            >
                                <MenuItem value={dealRequired} selected={dealRequired}>
                                    {dealRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Order Management Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={orderMgtAllowed}
                                disabled
                            >
                                <MenuItem value={orderMgtAllowed} selected={orderMgtAllowed}>
                                    {orderMgtAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Product Management Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={prdMgtAllowed}
                                disabled
                            >
                                <MenuItem value={prdMgtAllowed} selected={prdMgtAllowed}>
                                    {prdMgtAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                label="Order Sell Report Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={orderSellReportAllowed}
                                disabled
                            >
                                <MenuItem
                                    value={orderSellReportAllowed}
                                    selected={orderSellReportAllowed}
                                >
                                    {orderSellReportAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Order Sell Report Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={isPromoCodeAllowed}
                                disabled
                            >
                                <MenuItem
                                    value={isPromoCodeAllowed}
                                    selected={isPromoCodeAllowed}
                                >
                                    {isPromoCodeAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Sign Up</Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                label="Merchant Required"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={merchantRequired || ""}
                                disabled
                            >
                                <MenuItem value={merchantRequired} selected={merchantRequired}>
                                    {dealRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                label="Dealer Mapping Required"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={dealerMappingRequired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={dealerMappingRequired}
                                    selected={dealerMappingRequired}
                                >
                                    {dealRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Prefix Account Id"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={prefixAccountId || ""}
                                disabled
                            >
                                <MenuItem value={prefixAccountId} selected={prefixAccountId}>
                                    {prefixAccountId}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        {/* changes */}

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                label="Email Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={emailAllowed || ""}
                                disabled
                            >
                                <MenuItem value={emailAllowed} selected={emailAllowed}>
                                    {emailAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="SMS Allowed"
                                fullWidth
                                variant="standard"
                                value={smsAllowed || ""}
                                disabled
                            >
                                <MenuItem value={smsAllowed} selected={smsAllowed}>
                                    {smsAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="
                Business Signup Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={businessSignupAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={businessSignupAllowed}
                                    selected={businessSignupAllowed}
                                >
                                    {smsAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                label="Max UBO Count"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={maxUboCount || ""}
                                disabled
                            >
                                <MenuItem value={maxUboCount} selected={maxUboCount}>
                                    {maxUboCount}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Max Director Count"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={maxDirectorCount || ""}
                                disabled
                            >
                                <MenuItem value={maxDirectorCount} selected={maxDirectorCount}>
                                    {maxDirectorCount}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="AutoFilled Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={autoFilledAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={autoFilledAllowed}
                                    selected={autoFilledAllowed}
                                >
                                    {autoFilledAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Add Bank During SignUp"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={addBankDuringSignUp || ""}
                                disabled
                            >
                                <MenuItem
                                    value={addBankDuringSignUp}
                                    selected={addBankDuringSignUp}
                                >
                                    {addBankDuringSignUp}
                                </MenuItem>
                            </TextField>
                        </Grid>



                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="DOB Required"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={dobReqired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={dobReqired}
                                    selected={dobReqired}
                                >
                                    {dobReqired}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Nationality Required"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={nationalityRequired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={nationalityRequired}
                                    selected={nationalityRequired}
                                >
                                    {nationalityRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="KYC Required"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={kycRequired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={kycRequired}
                                    selected={kycRequired}
                                >
                                    {kycRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12}>
                            <Box style={{ marginTop: "10px" }}>
                                <Typography>Sign Up Consent</Typography>
                                <textarea id="w3review" rows="5" style={{ minWidth: '66%' }}
                                    name="getSignUpConsent"
                                    disabled

                                    value={getSignUpConsent || ""}
                                    onChange={handleChange}
                                >
                                </textarea>
                            </Box>
                        </Grid>

                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Two Factor Authentication </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                // id="name"
                                label="SMS OTP During Login Allowed"
                                fullWidth
                                variant="standard"
                                value={twofaSmsOtpAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={twofaSmsOtpAllowed}
                                    selected={twofaSmsOtpAllowed}
                                >
                                    {twofaSmsOtpAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                // id="name"
                                label="Email OTP During Login Allowed"
                                fullWidth
                                variant="standard"
                                value={twofaEmailOtpAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={twofaEmailOtpAllowed}
                                    selected={twofaEmailOtpAllowed}
                                >
                                    {twofaEmailOtpAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="2FA Configuration By User"
                                fullWidth
                                variant="standard"
                                value={twofaConfigurationUser || ""}
                                disabled
                            >
                                <MenuItem value={twofaConfigurationUser} selected={twofaConfigurationUser}>
                                    {twofaConfigurationUser}
                                </MenuItem>
                            </TextField>
                        </Grid>


                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="2FA Google Authenticator"
                                fullWidth
                                variant="standard"
                                value={twofaconfigurationGoogle || ""}
                                disabled
                            >
                                <MenuItem value={twofaconfigurationGoogle} selected={twofaconfigurationGoogle}>
                                    {twofaconfigurationGoogle}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">Login</Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="New Device Check Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                defaultValue={role}
                                value={newDeviceCheckAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={newDeviceCheckAllowed}
                                    selected={newDeviceCheckAllowed}
                                >
                                    {newDeviceCheckAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="
                Change Password Allowed"
                                fullWidth
                                variant="standard"
                                value={changePasswordAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={changePasswordAllowed}
                                    selected={changePasswordAllowed}
                                >
                                    {changePasswordAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Customer Creation Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={custCreationAll || ""}
                                disabled
                            >
                                <MenuItem
                                    value={custCreationAll}
                                    selected={custCreationAll}
                                >
                                    {custCreationAll}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Prepaid Card </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Customer Activate Card Required"
                                fullWidth
                                variant="standard"
                                value={customerActivateCardRequired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={customerActivateCardRequired}
                                    selected={customerActivateCardRequired}
                                >
                                    {customerActivateCardRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Prepaid Card Feature Required"
                                fullWidth
                                variant="standard"
                                value={prepaidCardFeatureRequired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={prepaidCardFeatureRequired}
                                    selected={prepaidCardFeatureRequired}
                                >
                                    {prepaidCardFeatureRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                variant="standard"

                                label="
                Applying Prepaid Card During SignUp"
                                fullWidth
                                value={applyingPrepaidCardDuringSignUp || ""}
                                disabled
                            >
                                <MenuItem
                                    value={applyingPrepaidCardDuringSignUp}
                                    selected={applyingPrepaidCardDuringSignUp}
                                >
                                    {applyingPrepaidCardDuringSignUp}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Wallet Settings </Typography>
                            </Alert>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Activity Log Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={activityLogAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={activityLogAllowed}
                                    selected={activityLogAllowed}
                                >
                                    {activityLogAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                variant="standard"

                                id="name"
                                label="
                Wallet Transfer Allowed"
                                fullWidth
                                value={walletTransferAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={walletTransferAllowed}
                                    selected={walletTransferAllowed}
                                >
                                    {walletTransferAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                label="
                Loyalty Points Allowed"
                                fullWidth
                                variant="standard"
                                value={walletHistoryAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={walletHistoryAllowed}
                                    selected={walletHistoryAllowed}
                                >
                                    {walletHistoryAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                variant="standard"

                                label="
                Wallet History Allowed"
                                fullWidth
                                type="text"
                                name="role"
                                value={loyaltyPointsAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={loyaltyPointsAllowed}
                                    selected={loyaltyPointsAllowed}
                                >
                                    {loyaltyPointsAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Integration"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={integration || ""}
                                disabled
                            >
                                <MenuItem value={integration} selected={integration}>
                                    {integration}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                id="name"
                                label="Transaction History Allowed"
                                fullWidth
                                variant="standard"
                                value={transactionHistoryAllowed || ""}
                                disabled
                            >
                                <MenuItem value={transactionHistoryAllowed} selected={transactionHistoryAllowed}>
                                    {transactionHistoryAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>


                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Load Configuration</Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Load Money Allowed"
                                fullWidth
                                variant="standard"
                                value={loadMoneyAllowed || ""}
                                disabled
                            >
                                <MenuItem value={loadMoneyAllowed} selected={loadMoneyAllowed}>
                                    {loadMoneyAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="
                Load with Wallet Allowed"
                                fullWidth
                                variant="standard"
                                value={loadwithWalletAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={loadwithWalletAllowed}
                                    selected={loadwithWalletAllowed}
                                >
                                    {loadwithWalletAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                // autoFocus
                                label="
                Load Security Allowed"
                                fullWidth
                                name="loadSecurityAllowed"
                                value={loadSecurityAllowed || ""}
                                disabled
                                variant="standard"
                            >
                                <MenuItem
                                    value={loadSecurityAllowed}
                                    selected={loadSecurityAllowed}
                                >
                                    {loadSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">
                                    {" "}
                                    Withdraw Configuration{" "}
                                </Typography>
                            </Alert>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Withdraw Money Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={withdrawMoneyAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={withdrawMoneyAllowed}
                                    selected={withdrawMoneyAllowed}
                                >
                                    {withdrawMoneyAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                variant="standard"

                                id="name"
                                label="
                Withdraw Verification Allowed"
                                fullWidth
                                name="role"
                                value={withdrawVerificationAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={withdrawVerificationAllowed}
                                    selected={withdrawVerificationAllowed}
                                >
                                    {withdrawVerificationAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                variant="standard"

                                id="name"
                                label="
                withdraw Security Allowed"
                                fullWidth
                                value={withdrawSecurityAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={withdrawSecurityAllowed}
                                    selected={withdrawSecurityAllowed}
                                >
                                    {withdrawSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>

                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">
                                    {" "}
                                    Send Configuration{" "}
                                </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Send Money Allowed"
                                fullWidth
                                variant="standard"
                                value={sendMoneyAllowed || ""}
                                disabled
                            >
                                <MenuItem value={sendMoneyAllowed} selected={sendMoneyAllowed}>
                                    {sendMoneyAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                variant="standard"

                                id="name"
                                label="
                Send Money Merchant Required"
                                fullWidth
                                value={sendMoneyMerchantRequired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={sendMoneyMerchantRequired}
                                    selected={sendMoneyMerchantRequired}
                                >
                                    {sendMoneyMerchantRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                disabled
                                select
                                // autoFocus
                                label="
                Send Security Allowed"
                                fullWidth
                                name=""
                                variant="standard"
                                value={sendSecurityAllowed}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value={sendSecurityAllowed}
                                    selected={sendSecurityAllowed}
                                >
                                    {sendSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                variant="standard"

                                label="
                Request Security Allowed"
                                fullWidth
                                name="requestSecurityAllowed"
                                value={requestSecurityAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={requestSecurityAllowed}
                                    selected={requestSecurityAllowed}
                                >
                                    {requestSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="
                Request Money Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                value={requestMoneyAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={requestMoneyAllowed}
                                    selected={requestMoneyAllowed}
                                >
                                    {requestMoneyAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">
                                    {" "}
                                    Pay Configuration{" "}
                                </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Pay Allowed"
                                fullWidth
                                variant="standard"
                                value={activityLogAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={activityLogAllowed}
                                    selected={activityLogAllowed}
                                >
                                    {activityLogAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="
                Pay Option"
                                fullWidth
                                variant="standard"
                                value={payOption || ""}
                                disabled
                            >
                                <MenuItem value={payOption} selected={payOption}>
                                    {payOption}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                label="
                Pay Security Allowed"
                                fullWidth
                                variant="standard"
                                value={paySecurityAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={paySecurityAllowed}
                                    selected={paySecurityAllowed}
                                >
                                    {paySecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                variant="standard"

                                label="
                Purchase Security Allowed"
                                fullWidth
                                value={purchaseSecurityAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={purchaseSecurityAllowed}
                                    selected={purchaseSecurityAllowed}
                                >
                                    {purchaseSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">
                                    {" "}
                                    Profile Configuration{" "}
                                </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                label="
                My Card Allowed"
                                fullWidth
                                variant="standard"
                                value={myCardAllowed || ""}
                                disabled
                            >
                                <MenuItem value={myCardAllowed} selected={myCardAllowed}>
                                    {myCardAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                label="
                My Bank Allowed"
                                fullWidth
                                variant="standard"
                                value={myBankAllowed || ""}
                                disabled
                            >
                                <MenuItem value={myBankAllowed} selected={myBankAllowed}>
                                    {myBankAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                // margin="dense"
                                label="
                Wallet Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={walletAllowed || ""}
                                disabled
                            >
                                <MenuItem value={walletAllowed} selected={walletAllowed}>
                                    {walletAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                variant="standard"

                                // autoFocus
                                label="
                User Management "
                                fullWidth
                                value={userManagement || ""}
                                disabled
                            >
                                <MenuItem value={userManagement} selected={userManagement}>
                                    {userManagement}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                id="name"
                                label="Store Required  "
                                fullWidth
                                variant="standard"
                                value={storeRequired || ""}
                                disabled
                            >
                                <MenuItem value={storeRequired} selected={storeRequired}>
                                    {storeRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                id="name"
                                label="My IBAN Allowed"
                                fullWidth
                                variant="standard"
                                value={myIbanAllowed || ""}
                                disabled
                            >
                                <MenuItem value={myIbanAllowed} selected={myIbanAllowed}>
                                    {myIbanAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                id="name"
                                label="Profile Setting Allowed"
                                fullWidth
                                variant="standard"
                                value={profileSettingsAllowed || ""}
                                disabled
                            >
                                <MenuItem value={profileSettingsAllowed} selected={profileSettingsAllowed}>
                                    {profileSettingsAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                id="name"
                                label="SEPA Allowed"
                                fullWidth
                                variant="standard"
                                value={isSEPAAllowed || ""}
                                disabled
                            >
                                <MenuItem value={isSEPAAllowed} selected={isSEPAAllowed}>
                                    {isSEPAAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">
                                    {" "}
                                    Pay Order Configuration{" "}
                                </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                variant="standard"

                                label="
                Pay Order Allowed"
                                fullWidth
                                value={payOrderAllowed || ""}
                                disabled
                            >
                                <MenuItem value={payOrderAllowed} selected={payOrderAllowed}>
                                    {payOrderAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="
                Pay Received Allowed"
                                fullWidth
                                variant="standard"
                                value={payReceivedAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={payReceivedAllowed}
                                    selected={payReceivedAllowed}
                                >
                                    {payReceivedAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                // autoFocus
                                label="
                Pay Order Security Allowed"
                                value={payOrderSecurityAllowed || ""}
                                disabled
                                fullWidth
                                variant="standard"
                            >
                                <MenuItem
                                    value={payOrderSecurityAllowed}
                                    selected={payOrderSecurityAllowed}
                                >
                                    {payOrderSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">
                                    {" "}
                                    Other Configuration{" "}
                                </Typography>
                            </Alert>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="
                Cashout Allowed"
                                fullWidth
                                variant="standard"
                                value={cashoutAllowed || ""}
                                disabled
                            >
                                <MenuItem value={cashoutAllowed} selected={cashoutAllowed}>
                                    {cashoutAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Check Deposit Allowed"
                                fullWidth
                                variant="standard"
                                value={checkDepositAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={checkDepositAllowed}
                                    selected={checkDepositAllowed}
                                >
                                    {checkDepositAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                margin="dense"
                                variant="standard"

                                select
                                // autoFocus
                                label="
                 CashIn Allowed"
                                fullWidth
                                value={cashInAllowed || ""}
                                disabled
                            >
                                <MenuItem value={cashInAllowed} selected={cashInAllowed}>
                                    {cashInAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                variant="standard"

                                // autoFocus
                                label="
                Request CashIn Allowed"
                                fullWidth
                                value={requestCashInAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={requestCashInAllowed}
                                    selected={requestCashInAllowed}
                                >
                                    {requestCashInAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Request CashOut Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={requestCashOutAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={requestCashOutAllowed}
                                    selected={requestCashOutAllowed}
                                >
                                    {requestCashOutAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                variant="standard"

                                label="
                Radio Allowed"
                                fullWidth
                                value={radioAllowed || ""}
                                disabled
                            >
                                <MenuItem value={radioAllowed} selected={radioAllowed}>
                                    {radioAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                label="
                Block Chain Allowed"
                                fullWidth
                                variant="standard"
                                value={blockChainAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={blockChainAllowed}
                                    selected={blockChainAllowed}
                                >
                                    {blockChainAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                label="
                Recharge Allowed"
                                fullWidth
                                variant="standard"
                                value={rechargeAllowed || ""}
                                disabled
                            >
                                <MenuItem value={rechargeAllowed} selected={rechargeAllowed}>
                                    {rechargeAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                // autoFocus
                                label="
                Bill Payment Allowed"
                                fullWidth
                                variant="standard"
                                value={billPaymentAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={billPaymentAllowed}
                                    selected={billPaymentAllowed}
                                >
                                    {billPaymentAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                label="
                CashOut Security Allowed"
                                fullWidth
                                variant="standard"
                                value={cashoutSecurityAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={cashoutSecurityAllowed}
                                    selected={cashoutSecurityAllowed}
                                >
                                    {cashoutSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                margin="dense"

                                label="
                CashIn Security Allowed"
                                fullWidth
                                variant="standard"
                                value={cashinSecurityAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={cashinSecurityAllowed}
                                    selected={cashinSecurityAllowed}
                                >
                                    {cashinSecurityAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                Donation Allowed"
                                fullWidth
                                variant="standard"
                                value={donationAllowed || ""}
                                disabled
                            >
                                <MenuItem value={donationAllowed} selected={donationAllowed}>
                                    {donationAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>



                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Voucher Configuration </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Voucher Purchase Allowed"
                                fullWidth
                                variant="standard"
                                value={voucherPurchaseAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={voucherPurchaseAllowed}
                                    selected={voucherPurchaseAllowed}
                                >
                                    {voucherPurchaseAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Transaction History Allowed"
                                fullWidth
                                variant="standard"
                                value={transactionHistoryAllowedv || ""}
                                disabled
                            >
                                <MenuItem
                                    value={transactionHistoryAllowedv}
                                    selected={transactionHistoryAllowedv}
                                >
                                    {transactionHistoryAllowedv}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="
                My Voucher Allowed"
                                fullWidth
                                variant="standard"
                                value={myVoucherAllowed || ""}
                                disabled
                            >
                                <MenuItem value={myVoucherAllowed} selected={myVoucherAllowed}>
                                    {myVoucherAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Redeem Password Allowed"
                                fullWidth
                                variant="standard"
                                value={redeemPasswordAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={redeemPasswordAllowed}
                                    selected={redeemPasswordAllowed}
                                >
                                    {redeemPasswordAllowed}
                                </MenuItem>{" "}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Redeem Authentication"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={redeemAuthentication || ""}
                                disabled
                            >
                                <MenuItem
                                    value={redeemAuthentication}
                                    selected={redeemAuthentication}
                                >
                                    {redeemAuthentication}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Redeem Exact Order Amount"
                                fullWidth
                                variant="standard"
                                value={redeemExactOrderAmount || ""}
                                disabled
                            >
                                <MenuItem
                                    value={redeemExactOrderAmount}
                                    selected={redeemExactOrderAmount}
                                >
                                    {redeemExactOrderAmount}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Settlement Report Required"
                                fullWidth
                                variant="standard"
                                defaultValue={"Select Order Sell Report Allowed" || role}
                                value={settlementReportRequired || ""}
                                disabled
                            >
                                <MenuItem
                                    value={settlementReportRequired}
                                    selected={settlementReportRequired}
                                >
                                    {settlementReportRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="API Key Required"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                defaultValue={"Select Order Sell Report Allowed" || role}
                                onChange={handleChange}
                                value={aPIKeyRequired || ""}
                                disabled
                            >
                                <MenuItem value={aPIKeyRequired} selected={aPIKeyRequired}>
                                    {aPIKeyRequired}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Bank Configuration </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Send To Contact Allowed"
                                fullWidth
                                variant="standard"
                                value={sendToContactAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={sendToContactAllowed}
                                    selected={sendToContactAllowed}
                                >
                                    {sendToContactAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Send To Self Allowed"
                                fullWidth
                                variant="standard"
                                value={sendToSelfAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={sendToSelfAllowed}
                                    selected={sendToSelfAllowed}
                                >
                                    {sendToSelfAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Send To Other Allowed"
                                fullWidth
                                variant="standard"
                                value={sendToOtherAllowed || ""}
                                disabled
                            >
                                <MenuItem value={sendToOtherAllowed} selected={sendToOtherAllowed}>
                                    {sendToOtherAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                label="Check Balance Allowed"
                                fullWidth
                                variant="standard"
                                value={checkBalanceAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={checkBalanceAllowed}
                                    selected={checkBalanceAllowed}
                                >
                                    {checkBalanceAllowed}
                                </MenuItem>{" "}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // required
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Manage Beneficiaries Allowed"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="role"
                                value={manageBeneficiariesAllowed || ""}
                                disabled
                            >
                                <MenuItem
                                    value={manageBeneficiariesAllowed}
                                    selected={manageBeneficiariesAllowed}
                                >
                                    {manageBeneficiariesAllowed}
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1"> Refund Configuration </Typography>
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Refund"
                                fullWidth
                                variant="standard"
                                value={getRefund || ""}
                                disabled
                            >
                                <MenuItem
                                    value={getRefund}
                                    selected={getRefund}
                                >
                                    {getRefund}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Partial Refund"
                                fullWidth
                                variant="standard"
                                value={getPartialRefund || ""}
                                disabled
                            >
                                <MenuItem
                                    value={getPartialRefund}
                                    selected={getPartialRefund}
                                >
                                    {getPartialRefund}
                                </MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <TextField
                                select
                                // autoFocus
                                margin="dense"
                                id="name"
                                label="Full Refund"
                                fullWidth
                                variant="standard"
                                value={getFullRefund || ""}
                                disabled
                            >
                                <MenuItem value={getFullRefund} selected={getFullRefund}>
                                    {getFullRefund}
                                </MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2} style={{ padding: "25px" }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="text-center themeBackground"
                                variant="secondary"
                                fullWidth={true}
                            >
                                <Typography variant="body1">
                                    {" "}
                                    Transaction Configuration{" "}
                                </Typography>
                            </Alert>
                        </Grid>

                         <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                disabled
                                id="name"
                                label="Is Country Selection"
                                fullWidth
                                variant="standard"
                                name="countrySelection"
                                onChange={handleChange}
                                value={countrySelection || ""}
                            >
                                {/* <MenuItem value="D">D</MenuItem> */}
                                <MenuItem value="Y">Y</MenuItem>
                                <MenuItem value="N">N</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                disabled
                                id="name"
                                label="Is Terms And Conditions"
                                fullWidth
                                variant="standard"
                                name="getIsTermsAndConditions"
                                onChange={handleChange}
                                value={getIsTermsAndConditions || ""}
                            >
                                {/* <MenuItem value="D">D</MenuItem> */}
                                <MenuItem value="Y">Y</MenuItem>
                                <MenuItem value="N">N</MenuItem>
                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                // autoFocus
                                disabled
                                // disabled={getIsTermsAndConditions === "N" ? true : false}
                                margin="dense"
                                id="name"
                                label="Terms URL"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="getTermsURL"
                                value={getTermsURL}
                                onChange={handleChange}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                disabled
                                id="name"
                                label="Is Auto Redirect"
                                fullWidth
                                variant="standard"
                                name="getIsAutoRedirect"
                                onChange={handleChange}
                                value={getIsAutoRedirect || ""}
                            >
                                {/* <MenuItem value="D">D</MenuItem> */}
                                <MenuItem value="Y">Y</MenuItem>
                                <MenuItem value="N">N</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                // autoFocus
                                disabled
                                // disabled={getIsTermsAndConditions === "N" ? true : false}
                                margin="dense"
                                id="name"
                                label="Enter Time In Milliseconds"
                                fullWidth
                                variant="standard"
                                type="text"
                                name="getRedirectTime"
                                value={getRedirectTime}
                                onChange={handleChange}
                            />
                        </Grid>


                        <Grid item xs={12}>
                            <Box style={{ marginTop: "10px" }}>
                                <Typography>Consent</Typography>
                                <textarea id="w3review" rows="5" style={{ minWidth: '66%' }}
                                    type="text"
                                    name="getTransactionConsent"
                                    disabled
                                    value={getTransactionConsent || ""}
                                    onChange={handleChange}
                                >
                                </textarea></Box>
                        </Grid>
                    </Grid>
                </Card>
            </Layout>
        </>
    );
}

export default AdminViewConfiguration
